import { Link } from "@tanstack/react-router"
import type { ReactNode } from "react"

import { useText } from "../i18n/use-text"
import { cx } from "../lib/cx"
import { Counter } from "../ui/counter"
import styles from "./nav-sidebar.module.css"
import type { NavEntry } from "./use-nav"
import { UserPanel } from "./user-panel"

/**
 * Боковая навигация 200 px — раскладка стойки (1366×768 и шире).
 *
 * ПОДПИСИ ПОЛНЫЕ, И МЕСТО ПОД НИХ ЕСТЬ. Интерфейс переводится с первого дня, а немецкий
 * длиннее русского примерно в полтора раза: «Тариф и оплата» → «Tarif und Zahlung»,
 * «Каталог» → «Leistungskatalog». Поэтому у пункта нет фиксированной ширины, длинная
 * подпись обрезается многоточием, а полное название всегда остаётся в подсказке
 * и в доступном имени ссылки — обрезанный текст не должен становиться недоступным.
 */
export function NavSidebar(props: {
  readonly entries: readonly NavEntry[]
  readonly tenantName: string
  readonly userName: string
  readonly roleName: string
}): ReactNode {
  const t = useText()
  return (
    <nav className={styles.nav} aria-label="Разделы кабинета">
      <div className={styles.brand}>
        <div className={styles.brandName}>planerius</div>
        <div className={styles.brandTenant} title={props.tenantName}>
          {props.tenantName}
        </div>
      </div>

      <div className={styles.list}>
        {props.entries.map((entry) => (
          <Link
            key={entry.section.id}
            to={entry.section.path}
            title={t(entry.section.textKey)}
            aria-current={entry.active ? "page" : undefined}
            className={cx(styles.item, entry.active ? styles.itemActive : undefined)}
          >
            <span className={styles.itemLabel}>{t(entry.section.textKey)}</span>
            {entry.badge === undefined ? null : (
              <Counter value={entry.badge} label="требуют действия" tone="on-nav" />
            )}
            {entry.dot ? (
              <span className={styles.dot}>
                <span className="plnr-visually-hidden">требует внимания</span>
              </span>
            ) : null}
          </Link>
        ))}
      </div>

      <UserPanel userName={props.userName} roleName={props.roleName} onNav />
    </nav>
  )
}
